/**
  * @desc new responsive lazyload image script, servering the image depending on parent-wrapper width and aspect-ratio parameter
  * html example <img src="/media/1001/on-top-of-earth.jpg" data-height-ratio="1" data-focalpoint="0.96885813148788924,0.49090909090909091" data-mode="crop" data-quality="75" data-filter="greyscale" class="img-circle" alt="Random alternative text" title="Random title 2" property="contentUrl" />
  * js init example: novicell.responsiveLazyloadImage.image();
  * js resize example: novicell.responsiveLazyloadImage.onResize();
  * js scroll example:
  * if($('.responsiveLazyload').length > 0)
  *     novicell.responsiveLazyloadImage.image();
  * @author Tommy Pedersen - TPE
  * @return generates img and removes noscript image
  * @requires jquery@1.11.3
  * @note: Just beautiful!
*/

var novicell = novicell || {};

novicell.responsiveLazyloadImage = novicell.responsiveLazyloadImage || function () {
    var self = this;
    var lastRefreshWidth = 0;
    var refreshWidth = 50;

    this.image = function (callback) {
        $('.responsiveLazyload').each(function () {
            if ($(this).parent().visible(true) || $(this).data("load") == "always") {
                if ($(this).first()) {
                    var figure = $(this).parent();
                    $(this).remove();
                    self.contructImage(figure);
                    lastRefreshWidth = window.innerWidth;
                    figure.addClass('lazyResizeReload');
                    if (typeof callback == 'function') {
                        callback();
                    }
                }
            }
        });
    }

    this.onResize = function (callback) {
        if (window.innerWidth > lastRefreshWidth + refreshWidth || window.innerWidth < lastRefreshWidth - refreshWidth) {
            $('.lazyResizeReload').each(function () {
                self.contructImage($(this));
                if (typeof callback == 'function') {
                    callback();
                }
            });
            lastRefreshWidth = window.innerWidth;
        }

    }

    this.contructImage = function (figure) {
        var $image = new Image();


        

        //data variables and images settings
        var width, height, heightRatio, focalPoint, mode, filter, quality;
        width = figure.width() != 0 ? figure.width() : (figure.data('parent') ? $(figure.data('parent')).width() : $(figure).parent().width());
        var ImageWidth = figure.data('imagesize');
        heightRatio = figure.data('height-ratio');
        height = !figure.data('height') && !heightRatio ? (figure.data('parent') ? $(figure.data('parent')).height() : $(figure).parent().height()) : figure.data('height');
        var origheight = height;
        crop = figure.data('crop');
        filter = figure.data('filter');
        quality = figure.data('quality') || 80;

        // Check if the height is set to be an object
        if($.isArray(height)) {
          height = self.getViewPortHeights(height);
        }

        // Calcuate height 
        if(heightRatio && width) {
          var h = heightRatio * width;
          height = h < height ? h : height;
          height = Math.floor(height);
        }

        // Up the height
        if (width < 1000) {
            width = Math.ceil(width * 1.5);
            height = Math.ceil(height * 1.5);
        }

        var newImageSrc = "/Admin/Public/GetImage.ashx?Image=" + figure.data('src');
        newImageSrc += width ? self.nextQuerySign(newImageSrc) + "width=" + ImageWidth : "";
        newImageSrc += height ? self.nextQuerySign(newImageSrc) + "height=" + height : "";
        newImageSrc += crop ? self.nextQuerySign(newImageSrc) + "crop=" + crop : "";
        newImageSrc += self.nextQuerySign(newImageSrc) + "quality=" + quality;

        $image.src = newImageSrc;
        figure.find('img').remove();
        figure.prepend($image);
        $image = figure.find('img');

        $image.attr('class', figure.data('class'));
        $image.attr('alt', figure.data('alt'));
        $image.attr('title', figure.data('title'));
        $image.attr('property', 'contentUrl');
        console.log(ImageWidth);
    }

    this.nextQuerySign = function (url) {
        return url.indexOf("?") > -1 ? "&" : "?";
    };

    this.getViewPortHeights = function(arr) {

      // Set the height as the highest number
      var newHeight = arr[0].height;

      arr.forEach(function(el){

        if ($(window).width() < el.viewport) {
           newHeight = el.height;
        }

      });

      return newHeight;

    }

    // public functions:
    return {
        image: image,
        onResize: onResize
    };
}();

(function ($) {

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    $.fn.visible = function (partial) {

        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

})(jQuery);